// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"our-initiatives_wrapper__UM3yv","initiatives":"our-initiatives_initiatives__4GL_g","skeleton-loading":"our-initiatives_skeleton-loading__qwlXR"};